























import { Component as TSXComponent } from "vue-tsx-support";
import { Component, Prop } from "vue-property-decorator";
import { ApiHelper } from "@/helpers/all";

interface Props {
  data: any;
}

interface Events {
}

@Component({
  inheritAttrs: false,
  components: {
  }
})
export default class FormEmail extends TSXComponent<Props, Events> {
  @Prop({ required: true })
  data!: any;

  stripTags(value: string) {
    return ApiHelper.stripTags(value);
  }
}
